module.exports = __webpack_public_path__ + "static/media/activnyikrym.76806309.jpg";